<template>
    <div class="modal fade" id="AddPlafondModal" tabindex="-1" role="dialog" ref="addPlafondModalRef"
        aria-labelledby="plafondModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="plafondModalLabel">Réajuster le plafond</h4>
                    <button class="btn-close py-0" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <h5 v-if="selectedCompte">Nouveau plafond pour le compte : {{ selectedCompte.intituleCompte }}</h5>
                    <Form ref="plafondForm" @submit="addPlafond" :validation-schema="plafondSchema">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                                    <label class="d-block text-black fw-semibold mb-10">
                                        Type d'opération <span class="text-danger">*</span>
                                    </label>
                                    <Field name="typeOperation" type="text" v-slot="{ field }">
                                        <Multiselect :searchable="true" :options="optionsOperation"
                                            v-model="field.value" v-bind="field"
                                            placeholder="Sélectionner le type d'opération" />
                                    </Field>
                                    <ErrorMessage name="typeOperation" class="text-danger" />
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                                    <label class="d-block text-black fw-semibold mb-10">
                                        Nouveau Plafond <span class="text-danger">*</span>
                                    </label>
                                    <Field name="plafond" type="text"
                                        class="form-control shadow-none fs-md-15 text-black"
                                        placeholder="Entrer le nouveau plafond" />
                                    <ErrorMessage name="plafond" class="text-danger" />
                                </div>
                            </div>

                            <div class="col-md-12 mt-3">
                                <div class="d-flex justify-content-start">
                                    <button class="btn btn-primary me-3" type="submit" ref="submitButton">
                                        Enregistrer
                                    </button>
                                    <button class="btn btn-danger" type="button" data-bs-dismiss="modal">
                                        Annuler
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import * as Yup from 'yup';
import ApiService from '@/services/ApiService';
import { error, success, hideModal } from '@/utils/utils';
import { Compte } from '@/models/Compte';
import Multiselect from '@vueform/multiselect';

export default defineComponent({
    name: "AddPlafondModal",
    components: {
        Form,
        Field,
        ErrorMessage,
        Multiselect,
    },
    props: {
        selectedCompte: {
            type: Object as () => Compte | undefined,
            default: undefined,
        },
    },
    setup(props, { emit }) {
        const plafondSchema = Yup.object().shape({
            typeOperation: Yup.string().required("Le type d'opération est obligatoire"),
            plafond: Yup.string().required('Le plafond est obligatoire'),
        });

        const plafondForm = ref<any>(null);
        const addPlafondModalRef = ref<HTMLElement | null>(null);
        const submitButton = ref<HTMLButtonElement | null>(null);
        const optionsOperation = ref([
            { value: '1', label: 'Augmenter le plafond' },
            { value: '2', label: 'Diminuer le plafond' },
        ]);


        const addPlafond = async (values, { resetForm }) => {
            if (!props.selectedCompte?.id) {
                error('Compte non sélectionné');
                return;
            }

            if (submitButton.value) {
                submitButton.value.disabled = true;
            }

            // Ajouter l'ID du compte aux données envoyées
            values.compteId = props.selectedCompte.id;

            try {
                const { data } = await ApiService.post(`/plafonds/comptes/${props.selectedCompte.id}`, values);
                if (data.code === 201) {
                    success(data.message);
                    resetForm();
                    hideModal(addPlafondModalRef.value);
                    emit('close');
                }
            } catch ({ response }) {
                if (submitButton.value) {
                    submitButton.value.disabled = false;
                }
                error(response?.data?.message || 'Erreur lors de l’ajout de la plafond');
            }
        };

        onMounted(() => {

        });

        return {
            plafondSchema,
            addPlafond,
            plafondForm,
            optionsOperation,
            addPlafondModalRef,
            submitButton,
        };
    },
});
</script>

<style scoped>
.modal-content {
    border-radius: 8px;
}

.modal-body h5 {
    margin-bottom: 20px;
}

.form-group {
    margin-bottom: 20px;
}

.text-danger {
    font-size: 12px;
    margin-top: 5px;
}
</style>